import React from "react";
import Logo from "../../../New_Web_design/logo.png";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate } from "react-router-dom";
import Twitter_old from "../../../New_Web_design/twitter_icon_old.png";
import Twitter from "../../../New_Web_design/twitter_icon.png";
import TikTok from "../../../New_Web_design/tik_tok_icon.png";
import Linkedin from "../../../New_Web_design/linkedin_icon.png";
import Facebook from "../../../New_Web_design/facebook_icon.png";
import Youtube from "../../../New_Web_design/youtube_icon.png";
import Insta from "../../../New_Web_design/insta_icon.png";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import logo_img from "../../../New_Web_design/W_Logo.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";

import PhoneInputField from "./PhoneInputField";

export default function Footer() {
  const history = useNavigate();
  const [logo, setLogo] = React.useState([
    {
      img: Twitter,
      url: "https://twitter.com/WolfWinPlay",
    },
    {
      img: TikTok,
      url: "https://www.tiktok.com/@wolfwin94?_t=8gu5HRvLh9C&_r=1",
    },
    {
      img: Linkedin,
      url: "https://www.linkedin.com/in/wolf-win-92425125b",
    },

    {
      img: Facebook,
      url: "https://www.facebook.com/profile.php?id=61552923956287&mibextid=LQQJ4d",
    },

    {
      img: Youtube,
      url: "https://www.youtube.com/channel/UCJIPz8gYgYg89Tqe7mqc0LQ",
    },

    {
      img: Insta,
      url: "https://instagram.com/wolfwingame?igshid=MzMyNGUyNmU2YQ==",
    },
  ]);
  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address format")
      .required("Email is required"),
    message: Yup.string().required("message is required"),
    name: Yup.string().required("Name is required"),
    phoneNo: Yup.string().required("PhoneNo is required"),
  });

  return (
    <div>
      <div className="container" id="contact">
        <div className="row mt-5">
          <div className="col-sm-12 col-md-7 col-lg-7 order-md-1">
            <div
              className="mt-4 last_logo"
              style={{ display: "flex", justifyContent: "start" }}
            >
              <img
                alt=""
                style={{ width: "55px" }}
                src={logo_img}
                className="d-inline-block align-top navWidthHeight"
              />

              <div>
                <p
                  className="sub-header mb-0 px-2"
                  style={{
                    fontFamily: "NunitoBlack",
                    color: "white",
                    zIndex: 1,
                    lineHeight: "37px",
                  }}
                >
                  WolfW<span class="i">i</span>n
                </p>
                <p
                  className="px-2 mb-0"
                  style={{
                    fontFamily: "NunitoBoldItalic",
                    color: "#929498",
                    fontSize: "15px",
                  }}
                >
                  Skill Up - Cash Out
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-center justify-content-lg-start">
              <p
                className="mt-3 text-center"
                style={{
                  fontFamily: "JosefinSans",
                  color: "#929498",
                  fontSize: "20px",
                }}
              >
                <b>Wolfwin is owned by DWIJA LAB PRIVATE LIMITED</b>
              </p>
            </div>

            <h2
              className="mt-2 text-sm-start"
              style={{
                fontFamily: "JosefinSans",
                color: "white",
                textAlign: "center",
              }}
            >
              Disclaimer
            </h2>
            <div className="mt-4">
              <p
                style={{
                  fontFamily: "JosefinSans",
                  color: "#929498",
                  textAlign: "justify",
                  fontSize: "20px",
                }}
              >
                <b>
                  With full compliance to the laws and regulations, WolfWin
                  operates legally, backed by expert opinions from top
                  industry-leading lawyers.
                </b>
              </p>
            </div>
            <div className="d-flex justify-content-center justify-content-lg-start">
              <div>
                <div style={{ display: "flex" }} className="my-2 ">
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      cursor: "pointer",
                    }}
                    className="footeIconHover mx-2 "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      fill="white"
                      class="bi bi-envelope-at-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2H2Zm-2 9.8V4.698l5.803 3.546L0 11.801Zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 9.671V4.697l-5.803 3.546.338.208A4.482 4.482 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671Z" />
                      <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034v.21Zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791Z" />
                    </svg>
                  </div>
                  <div>
                    <p
                      style={{
                        fontFamily: "JosefinSans",
                        color: "#929498",
                        fontSize: "20px",
                      }}
                    >
                      support@wolfwinplay.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex icons my-4">
              {logo.map((item) => (
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    cursor: "pointer",
                  }}
                  className="footeIconHover mx-2"
                >
                  <a
                    // href="https://www.instagram.com/wolfwin2023/"
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={item.img}
                      style={{ height: "100%", width: "100%" }}
                    />
                  </a>
                </div>
              ))}
            </div>
            <div class="d-flex py-4" style={{ alignItems: "center" }}>
              <div
                class="px-2"
                onClick={() => history("/TermsAndConditions")}
                style={{
                  fontFamily: "Nunito",
                  fontSize: "17px",

                  cursor: "pointer",
                  color: "#929498",
                }}
              >
                <b>Terms & Conditions</b>
              </div>
              <div
                class="px-2"
                onClick={() => history("/Faq")}
                style={{
                  fontFamily: "Nunito",
                  fontSize: "17px",

                  cursor: "pointer",
                  color: "#929498",
                }}
              >
                <b>FAQ'S</b>
              </div>
              <div
                class="px-2"
                onClick={() => history("/Privacy")}
                style={{
                  fontFamily: "Nunito",
                  fontSize: "17px",

                  cursor: "pointer",
                  color: "#929498",
                }}
              >
                <b>Privacy Policy</b>
              </div>
              <div
                class="px-2"
                onClick={() => history("/FairplayPolicy")}
                style={{
                  fontFamily: "Nunito",
                  fontSize: "17px",

                  cursor: "pointer",
                  color: "#929498",
                }}
              >
                <b>Fairplay Policy</b>
              </div>
              <div
                class="px-2"
                onClick={() => history("/ReturnPolicy")}
                style={{
                  fontFamily: "Nunito",
                  fontSize: "17px",
                  cursor: "pointer",
                  color: "#929498",
                }}
              >
                <b>Return Policy</b>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-5 col-lg-5 mt-2 order-md-2 order-first">
            <div
              style={{ borderRadius: "30px", border: "3px solid #929498" }}
              className=" p-4"
            >
              <h4 style={{ color: "white" }}>
                <b style={{ fontFamily: "JosefinSans" }}>Contact Us</b>
              </h4>
              {/* <div className="form-group mt-3">
                <input className="inputField" placeholder="Full Name" />
              </div>
              <div className="form-group mt-1">
                <input className="inputField" placeholder="Email" />
              </div>
              <PhoneInput
                country={"us"}
              />
              <div className="form-group mt-3">
                <textarea
                  className="inputField"
                  placeholder="Message"
                  rows={5}
                />
              </div>

              <button className="button" style={{ width: "100%" }}>
                Send Message
              </button> */}
              <Formik
                initialValues={{
                  name: "",
                  phoneNo: "",
                  email: "",
                  message: "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values, { resetForm }) => {
                  axios
                    .post(
                      `https://api.wolfwinplay.com/ContactForm/add-contactform`,
                      values
                    )
                    .then((res) => {
                      console.log("contact us res:::", res.data);
                      if (res.data.isValid) {
                        toast.success(res.data.message);
                        resetForm();
                      } else {
                        toast.error(res.data.message);
                      }
                    })
                    .catch((err) => {
                      console.log("contact us err :::", err);
                    });
                }}
              >
                {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                  <>
                    {" "}
                    <Form>
                      <Field
                        name="name"
                        type="text"
                        placeholder="Enter your name"
                        className={`mt-4  inputField
                          ${touched.name && errors.name ? "is-invalid" : ""}`}
                      />
                      <ErrorMessage
                        component="div"
                        name="name"
                        className="invalid-feedback"
                      />
                      <Field
                        type="email"
                        name="email"
                        placeholder="Enter your email address"
                        className={`inputField 
                          ${touched.email && errors.email ? "is-invalid" : ""}`}
                      />
                      <ErrorMessage
                        component="div"
                        name="email"
                        className="invalid-feedback"
                      />
                      {/* <PhoneInputField
                        label="Phone Number"
                        name="phoneNo"
                        country="us"
                      /> */}
                      <Field
                        component="textarea"
                        name="message"
                        rows={6}
                        placeholder="Enter your message"
                        className={`mt-3 inputField 
                          ${
                            touched.message && errors.message
                              ? "is-invalid"
                              : ""
                          }`}
                      />
                      <ErrorMessage
                        component="div"
                        name="message"
                        className="invalid-feedback"
                      />
                      <button
                        className="button"
                        style={{ width: "100%" }}
                        type="submit"
                      >
                        Send Message
                      </button>
                    </Form>
                  </>
                )}
              </Formik>
            </div>
          </div>
        </div>

        <div className="d-flex mt-4" style={{ justifyContent: "center" }}>
          <p
            style={{ fontFamily: "JosefinSans", color: "#929498" }}
            className="text-center"
          >
            <b>@2023 WolfWin Private Limited. All Rights Reserved.</b>
          </p>
        </div>
      </div>
    </div>
  );
}
